import { createContext, useContext, useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

const BrandContext = createContext(null);

const DEFAULT_BRAND = {
    name: "Sovereign",
    tagline: "Recruitment & White-Label Hub",
    color: "#C9A96E",
    logo: null,
    isWhiteLabel: false,
};

export function BrandProvider({ children }) {
    const [params] = useSearchParams();
    const brandName = params.get("brand");
    const color = params.get("color");
    const logo = params.get("logo");
    const tagline = params.get("tagline");

    const brand = useMemo(() => {
        if (!brandName && !color && !logo) return DEFAULT_BRAND;
        return {
            name: brandName || DEFAULT_BRAND.name,
            tagline: tagline || "Talent. Curated.",
            color: color || DEFAULT_BRAND.color,
            logo: logo || null,
            isWhiteLabel: true,
        };
    }, [brandName, color, logo, tagline]);

    useEffect(() => {
        document.documentElement.style.setProperty("--brand-accent", brand.color);
        document.title = brand.isWhiteLabel
            ? `${brand.name} — Talent`
            : "Sovereign Recruitment & White-Label Hub";
    }, [brand]);

    return <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>;
}

export function useBrand() {
    const ctx = useContext(BrandContext);
    if (!ctx) throw new Error("useBrand must be used inside BrandProvider");
    return ctx;
}
